import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Browser } from '@capacitor/browser';

// Beépített (in-app) fájl/PDF néző – natíven a window.open nem működik, ezért a fájlt blobként letöltjük
// (tokennel, a DataService-ben) és itt egy iframe-ben mutatjuk. „Megnyitás böngészőben" fallbackkel.
@Component({
  selector: 'app-fajl-nezo-modal',
  template: `
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title class="ion-text-nowrap">{{ cim }}</ion-title>
        <ion-buttons slot="end">
          <ion-button *ngIf="letoltesUrl" (click)="bongeszoben()" title="Megnyitás böngészőben">
            <ion-icon slot="icon-only" name="open-outline"></ion-icon>
          </ion-button>
          <ion-button (click)="bezar()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <iframe *ngIf="safeUrl" [src]="safeUrl" style="width:100%;height:100%;border:0"></iframe>
    </ion-content>
  `,
})
export class FajlNezoModalComponent implements OnInit {
  @Input() url = '';            // object URL (blob)
  @Input() cim = 'Dokumentum';
  @Input() letoltesUrl = '';    // abszolút URL a böngészős fallbackhoz
  safeUrl: SafeResourceUrl;

  constructor(private modalCtrl: ModalController, private san: DomSanitizer) {}

  ngOnInit() { if (this.url) this.safeUrl = this.san.bypassSecurityTrustResourceUrl(this.url); }

  async bongeszoben() { try { await Browser.open({ url: this.letoltesUrl }); } catch { /* ignore */ } }
  bezar() { try { if (this.url) URL.revokeObjectURL(this.url); } catch { /* ignore */ } this.modalCtrl.dismiss(); }
}
